import axios from "axios";

export default {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions:{
        invalidateCaches(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/cache/invalidateAll",{headers});
        },
        loadExchangeRate(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/tcmb/exchange-rates/eur", {headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}